import './index.scss'
import Questionizer from './components/questionizer';
import { useEffect, useState } from 'react';
import { useQuestionizerStore } from './types/state';

import Toggle from "./components/toggle.tsx";

const CONFIGS = [
  {
    label: "",
    path: "/client-configs/gebauede.json",
    icon: "client-icons/universal/wohngebaeude.svg",
    icon_active: "client-icons/active/wohngebaeude.svg",
  },
  {
    label: "",
    path: "/client-configs/nichtwohngebaeude.json",
    icon: "client-icons/universal/nichtwohngebaeude.svg",
    icon_active: "client-icons/active/nichtwohngebaeude.svg",
  },
    {
    label: "",
    path: "/client-configs/infra.json",
    icon: "client-icons/universal/infrastruktur.svg",
    icon_active: "client-icons/active/infrastruktur.svg",
  },
  {
    label: "",
    path: "/client-configs/mobile.json",
    icon: "client-icons/universal/e-mobilitaet.svg",
    icon_active: "client-icons/active/e-mobilitaet.svg",
  }


];

export default function App(props: {configBase: string | null | undefined}) {
  const configPath = useQuestionizerStore((s) => s.configPath);
  const config = useQuestionizerStore((state) => state.config);
  const loadConfig = useQuestionizerStore((state) => state.loadConfig);
  const requestStatistics = useQuestionizerStore((state) => state.requestStatistics);
  const [baseConfig, setBaseConfig] = useState<any>(null);
  const sendStatisticsInterval = 3000; 



  // ////////////////////////////////////////////////////////////

  // const setStep = useQuestionizerStore((state) => state.setStep);
  // const setPlz = useQuestionizerStore((state) => state.setPlz);
  // const toggleGewerk = useQuestionizerStore((state) => state.toggleGewerk);

  // useEffect(() => {
  //   //state mit allen eingaben versorgen 
  //   //zur letzten seite springen
  //   const gewerke_toggle_ids = [
  //     10,80,70,40,30,3000,20,90,103,102,101,109,105,104,106,203,201,202,204,206,207,305,306,307,301,304,303,401,402,801,802,806,804,
  //   ];
  //   if(baseConfig){
  //     console.log("---> bla");
  //     loadConfig(baseConfig.baseurl + "/client-configs/gebauede.json");
  //     setTimeout(() => {
  //       setPlz(61267);
  //       gewerke_toggle_ids.map((id)=>{
  //         toggleGewerk(id, true);
  //       });
  //       setStep(3, true);
  //       console.log("--->X");
  //     }, 100); 
  //   }
  // }, [baseConfig]);

  // ////////////////////////////////////////////////////////////

  useEffect(() => {
    if (!props.configBase) return;
    fetch(props.configBase)
      .then(res => res.json())
      .then(setBaseConfig)
      .catch(console.error);
  }, [props.configBase]);

  useEffect(() => {
    if (!configPath || !config) return;

    requestStatistics();
    const interval = setInterval(() => {
      requestStatistics();
    }, sendStatisticsInterval);

    return () => clearInterval(interval);
  }, [configPath, config]);
	
  if (!baseConfig) return null;
  const baseurl = baseConfig.baseurl;

  if (!configPath) {
    return (
      <div className="questionizer-container start w-full h-full flex flex-col font-sans">
        <h1 className="form__title">Online-Fördermittelauskunft</h1>
		<p>
		Wählen Sie den gewünschten Bereich und suchen Sie individuell für Ihr Vorhaben nach den geeigneten Förderprogrammen - Zuschüsse oder zinsgünstige Förderkredite für Ihre Investition.</p>
		<p>
		STARTEN SIE IHRE FÖRDERABFRAGE
		</p>
        <div className="form from-start">
			 <div className=" section section-0">
				<div className="section__inputs section__inputs--grid">
					{CONFIGS.map((c, idx) => (
					 
					  <Toggle
						key={c.path}
						id={idx.toString()}
						label={c.label}
						icon={baseurl + c.icon}
						icon_active={baseurl + c.icon_active}
						value={false}
						onChange={() => loadConfig(baseurl + c.path)}
					  />
					
					))}
				</div>
		   </div>
         </div>
      </div>
    );
  }

  if (!config) { return; }
 // if (!props.configPath || !config) { return; }

  let style = config.style;
  let parsed_style = style ? Object.keys(style)
    .map(element => [element, element.split(',').map(s => ".fbq "+s).join(',')])
    .map(element => `${element[1]}{${Object.keys(style[element[0]])
      .map( s => `${s.toString()}:${style[element[0]][s]}`)
      .join(';')}}`)
    .join(' ') : "";
  
    return <>
        <style>{parsed_style}</style>
        <Root />
    </>
  }

function Root(){
  return <div className={"questionizer-container w-full h-full flex flex-col font-sans "}>
      <Questionizer />
  </div>
}